module.exports = __webpack_public_path__ + "img/V3.5009284a.jpg";